/* eslint-disable class-methods-use-this */

import Request from '../models/request';

export default class RequestMapping {
  formatRequest = (request: {
    channel: Nullable<string>;
    fromParam: string | null;
  }) => {
    const { channel, fromParam } = request;
    return {
      canalProcedencia: channel,
      procedencia: fromParam,
    };
  };

  patchRequest = (request: Request): any => {
    return {
      identificadorCliente: request.customerId,
      estado: 'CREATE_REQUEST',
      tienePrestamoVehicular: request.hasVehicularLoan,
      entidadFinaciera: request.financialEntity,
      codigoLugarUso: request.placeOfUseCode,
      valorLugarUso: request.placeOfUseValue,
      fechaInicioCobertura: request.coverageStartDate,
      aceptaTerminosCondiciones: request.acceptsTermsAndConditions,
      consentimientoDatosPersonales: request.givesPersonalDataConsent,
      consentimientoVentaAsistida: request.assistedSaleConsent,
    };
  };

  getInitialRequestResponse = (request: any): Request => {
    return {
      id: request.identificadorSolicitud,
      coverageStartDate: request.fechaInicioCobertura,
    } as Request;
  };
}
